var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.48438H2V13.7084H22V5.48438Z",
    stroke: "#C93030",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37783 18.5213C7.29196 18.5213 8.033 17.7802 8.033 16.8661C8.033 15.952 7.29196 15.2109 6.37783 15.2109C5.4637 15.2109 4.72266 15.952 4.72266 16.8661C4.72266 17.7802 5.4637 18.5213 6.37783 18.5213Z",
    stroke: "#C93030",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3856 18.5213C12.2998 18.5213 13.0408 17.7802 13.0408 16.8661C13.0408 15.952 12.2998 15.2109 11.3856 15.2109C10.4715 15.2109 9.73047 15.952 9.73047 16.8661C9.73047 17.7802 10.4715 18.5213 11.3856 18.5213Z",
    stroke: "#C93030",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6211 15.4342V13.4141",
    stroke: "#C93030",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06766 13.7578L2.69141 15.9214",
    stroke: "#C93030",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7617 13.7578L15.141 15.8268",
    stroke: "#C93030",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerRedIcon);
export default __webpack_public_path__ + "static/media/trailer-red-icon.5e7752c3d8d11ddbc294bbba38472bb8.svg";
export { ForwardRef as ReactComponent };